import axios, { AxiosError, AxiosHeaders, AxiosResponseHeaders } from 'axios';

export type OtpVerifyResponse =
  | {
      data: { uid: string };
      error: null;
      headers: AxiosResponseHeaders | Partial<AxiosHeaders>;
    }
  | {
      data: null;
      error: { message: string };
      headers: null;
    };

export const verifyOtpApi = async (otpSessionToken: string, otpCode: string): Promise<OtpVerifyResponse> => {
  try {
    const { data, headers } = await axios({
      url: `${process.env.REACT_APP_API_SERVER_URL}/api/otp/verify`,
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      data: JSON.stringify({ otp_session_token: otpSessionToken, otp_code: otpCode })
    });
    return { data, error: null, headers };
  } catch (error) {
    return {
      data: null,
      error: {
        message: (error as AxiosError<{ error: string }>)?.response?.data?.error || (error as Error).message
      },
      headers: null
    };
  }
};

export const resendOtpApi = async (otpSessionToken: string) => {
  try {
    const { data } = await axios({
      url: `${process.env.REACT_APP_API_SERVER_URL}/api/otp/resend`,
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      data: JSON.stringify({ otp_session_token: otpSessionToken })
    });
    return { data: data as { message: string }, error: null };
  } catch (error) {
    return {
      data: null,
      error: { message: (error as AxiosError<{ error: string }>)?.response?.data?.error || (error as Error).message }
    };
  }
};
